export const debounce = <
  F extends (...args: Parameters<F>) => Promise<ReturnType<F>> | ReturnType<F>,
>(
  func: F,
  delay: number = 1000,
) => {
  let timer: ReturnType<typeof setTimeout> | null = null

  const debouncedFunction = (
    ...args: Parameters<F>
  ): Promise<Awaited<ReturnType<F>>> => {
    return new Promise(resolve => {
      if (timer !== null) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        resolve(
          Promise.resolve(func(...args)) as Promise<Awaited<ReturnType<F>>>,
        )
      }, delay)
    })
  }

  debouncedFunction.cancel = () => {
    if (timer !== null) {
      clearTimeout(timer)
      timer = null
    }
  }

  return debouncedFunction
}
